import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import {ContentBlock} from '@growcloud-io/dc/components/surface/ContentBlock';
import {Text} from '@growcloud-io/dc/content/Text';
import {CTAButton} from "@growcloud-io/dc/components/buttons/Buttons";
import StarIcon from '@mui/icons-material/Star';

import Stack from '@mui/material/Stack';
import {nextId} from "../utils/IdUtils";
import {newRowStack} from "../utils/UiUtils";
import Skeleton from '@mui/material/Skeleton';

export const PageItem = ({heroItemData,options}) => {
  return (
    <Stack direction={'column'}>
      <Typography variant={options.headerVariant} color="textSecondary">{heroItemData["pageTitle"]||heroItemData["label"]}</Typography>
      {renderItemAttributes(heroItemData,options)}
    </Stack>
  );
}

export const FeaturePageItem = ({featureData}) => {
  const options = {headerVariant: 'h4', itemVariant: 'body2'}
  return (
    <Stack direction={'column'}>
      <Typography variant={options.headerVariant} color="textSecondary">{featureData["label"]}</Typography>
      {featureData.items && (
        <Stack direction={'column'}>
          {renderFeatures(featureData.items,options)}
        </Stack>
      )}
      {featureData.links && (
        <Stack direction={'column'}>
          {renderLinks(featureData.links,options)}
        </Stack>
      )}
    </Stack>
  );
}

export const renderFeatures = (items,options) => {
  let itemsArray = [];
  for(let item of items){
    const panelId = nextId();
    itemsArray.push((
      <Stack direction={'row'} key={panelId} sx={newRowStack()}>
        <StarIcon style={{color:'gold'}}/>
        <Typography variant={options.itemVariant} color="textSecondary">{item.label}</Typography>
      </Stack>
    ))
  }
  return itemsArray;
}

export const HeroPageItem = ({heroItemData}) => {
  const options = {headerVariant: 'h3', itemVariant: 'h4'}
  return (
    <PageItem heroItemData={heroItemData} options={options}/>
  );
}

export const ImageOnLeftFrontPageItem = ({classes={},imageOnLeftData}) => {
  return (
    <ContentBlock elevation={0} backgroundColor="none">
      <Grid container spacing={4} justifyContent="center" alignContent="center" alignItems="center">
        {imageOnLeftData["imgSrc"] && (
          <Grid xs={12} md={6} lg={5}>
            <img
              className={classes.img}
              src={imageOnLeftData["imgSrc"]}
              alt={imageOnLeftData["imgAlt"]}
            />
          </Grid>
        )}
        <Grid xs={12} md={6} lg={7} style={{}}>
          {/*<Stack direction={'column'}>*/}
          {/*  <FrontPageItemHeader*/}
          {/*    pageTitle={imageOnLeftData["pageTitle"]}*/}
          {/*    subHeader={imageOnLeftData["subHeader"]}*/}
          {/*  />*/}
          {/*</Stack>*/}
          {renderItemAttributes(imageOnLeftData)}
        </Grid>
      </Grid>
    </ContentBlock>
  );
}

export const ImageOnRightFrontPageItem = ({classes={},imageOnRightData}) => (
  <ContentBlock elevation={0}>
    <Grid container spacing={4} justifyContent="center" alignContent="center" alignItems="center">
      <Grid xs={12} md={6} lg={7}>
        {/*<Stack direction={'column'}>*/}
        {/*  <FrontPageItemHeader*/}
        {/*    pageTitle={imageOnRightData["pageTitle"]}*/}
        {/*    subHeader={imageOnRightData["subHeader"]}*/}
        {/*  />*/}
        {/*</Stack>*/}
        {renderItemAttributes(imageOnRightData)}
      </Grid>
      <Grid container item xs={12} md={6} lg={5} justifyContent="center">
        <img
          className={classes.img}
          src={imageOnRightData["imgSrc"]}
          alt={imageOnRightData["imgAlt"]}
        />
      </Grid>
    </Grid>
  </ContentBlock>
);

export const ChartOnRightFrontPageItem = ({classes={},chartOnRightData,colorForNode,colorForEdge,colorScheme}) => (
  <ContentBlock elevation={0}>
    <Grid container spacing={4} justifyContent="center" alignContent="center" alignItems="center">
      <Grid xs={12} md={6} lg={7}>
        {chartOnRightData["subHeader"] && (
          <Stack direction={'column'}>
            <Text
              component="p"
              className={classes.largeMargin}
            >
              {chartOnRightData["subHeader"]}
            </Text>
          </Stack>
        )}

        {renderItemAttributes(chartOnRightData)}
      </Grid>

      <Grid container item xs={12} md={6} lg={5} justifyContent="center">
        {!chartOnRightData.chartSlug ? (
          <div
            width={480}
            height={360}
            svgElementStyles={{backgroundColor:'whitesmoke'}}
            colorScheme={colorScheme}
          >
            <Skeleton variant="rectangular"/>
          </div>
        ) : (
          <div
            slug={chartOnRightData.chartSlug}
            colorForNode={colorForNode}
            colorForEdge={colorForEdge}
            width={400}
            height={400}
          ><Skeleton variant="rectangular"/></div>
        )}
      </Grid>
    </Grid>
  </ContentBlock>
)

export const renderItemAttributes = (itemData,options) => {
  return (
    <>
      {itemData.items && (
        <Stack direction={'column'}>
          {renderItems(itemData.items,options)}
        </Stack>
      )}
      {itemData.links && (
        <Stack direction={'column'}>
          {renderLinks(itemData.links,options)}
        </Stack>
      )}
    </>
  )
}

export const renderItems = (items,options) => {
  let itemsArray = [];
  for(let item of items){
    itemsArray.push((
      <Stack direction={'row'} key={nextId()} sx={newRowStack()}>
        <StarIcon style={{color:'gold'}}/>
        <Typography variant={options.itemVariant} color="textSecondary">{item.label}</Typography>
      </Stack>
    ))
  }
  return itemsArray;
}

// const RenderAccordion = ({item,expanded,content,onClick,options}) => {
//   return (
//     <Accordion expanded={expanded}>
//       <AccordionSummary
//         expandIcon={(
//           <ExpandMoreIcon onClick={onClick} color={'primary'}/>
//         )}
//       ><>
//         <StarIcon style={{color:'gold'}}/>
//         <Typography variant={options.itemVariant} color="textSecondary">{item.label}</Typography>
//       </>
//       </AccordionSummary>
//       <AccordionDetails>
//         {content}
//       </AccordionDetails>
//     </Accordion>
//   )
// }

const makeContent = (item) => {
  debugger;
  return (
    <Stack direction={'column'}>
      <>TODO</>
    </Stack>
  )
}

export const renderLinks = (links,options) => {
  let itemsArray = [];
  if (links) {
    links.forEach(link => {
      itemsArray.push((
          <CTAButton
            key={nextId()}
            buttonColor="primary"
            buttonText={`MORE INFO: ${link.label}`}
            onClick={() => {
              window.location.href = `${link.to}`;
            }}
          />
      ))
    })
  }
  return itemsArray;
}